import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="-5 -4 17 18" fill="none">
    <path
      d="M2.91112 0.354C4.36712 0.354 5.53378 0.694666 6.41112 1.376C7.29778 2.048 7.74112 3.29867 7.74112 5.128C7.74112 6.91067 7.29778 8.17067 6.41112 8.908C5.53378 9.636 4.46512 10 3.20512 10H0.895117V0.354H2.91112ZM2.22512 1.418V8.95H3.30312C4.19912 8.95 4.92712 8.67467 5.48712 8.124C6.04712 7.57333 6.32712 6.57467 6.32712 5.128C6.32712 4.11067 6.18245 3.33133 5.89312 2.79C5.60378 2.23933 5.23512 1.87533 4.78712 1.698C4.33912 1.51133 3.81178 1.418 3.20512 1.418H2.22512Z"
      fill="currentColor"
    />
  </SvgIcon>
));
